import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Handler from "../../../Helpers/Handler";
import "../../../Assets/css/style.css";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const CreateCommunity = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({ name: "", description: "", type: "BUSINESS" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleType = (type) => {
    setForm({ ...form, type });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.name.trim()) return setError("Community name is required.");
    if (form.name.trim().length < 3) return setError("Name must be at least 3 characters.");

    setLoading(true);
    const res = await Handler({
      method: "POST",
      url: "/communities/create.php",
      data: form,
    });
    setLoading(false);

    if (res.success) {
      setSuccess("Community created successfully!");
      setTimeout(() => navigate("/user/feed"), 1400);
    } else {
      setError(res.message || "Failed to create community.");
    }
  };

  return (
    <MainLayout>
      <FeedLayout>
        <div className="comm-page">
          <div className="comm-header">
            <div className="header-text">
              <h2>Create Community</h2>
              <p>Launch your community and start connecting with others.</p>
            </div>
          </div>

          {/* Removed inline style for maxWidth to handle it via CSS for better alignment control */}
          <div className="comm-card create-form-card">
            {error && <div className="comm-alert error"><i className="bx bx-error-circle" />{error}</div>}
            {success && <div className="comm-alert success"><i className="bx bx-check-circle" />{success}</div>}

            <form className="comm-form" onSubmit={handleSubmit}>
              {/* Name */}
              <div className="form-group mb-4">
                <label className="form-label">Community Name <span className="text-danger">*</span></label>
                <input
                  className="form-control custom-input"
                  name="name"
                  placeholder="e.g. Chennai Founders Club"
                  value={form.name}
                  onChange={handleChange}
                  maxLength={80}
                />
              </div>

              {/* Description */}
              <div className="form-group mb-4">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control custom-input"
                  name="description"
                  placeholder="What is this community about?"
                  value={form.description}
                  onChange={handleChange}
                  rows={3}
                />
              </div>

              {/* Type Toggle */}
              <div className="form-group mb-4">
                <label className="form-label">Community Type</label>
                <div className="type-toggle-group">
                  {["BUSINESS", "EVENT"].map((t) => (
                    <button
                      key={t}
                      type="button"
                      className={`type-toggle-btn ${form.type === t ? "active" : ""}`}
                      onClick={() => handleType(t)}
                    >
                      <i className={`bx ${t === "BUSINESS" ? "bx-briefcase" : "bx-calendar-event"}`} />{" "}
                      {t.charAt(0) + t.slice(1).toLowerCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Submit Button - Left Aligned */}
              <div className="d-flex justify-content-start mt-3">
                <button type="submit" className="comm-btn-primary px-4 py-2" disabled={loading}>
                  {loading ? (
                    <><i className="bx bx-loader-alt bx-spin me-2" /> Creating…</>
                  ) : (
                    <><i className="bx bx-plus me-2" /> Create Community</>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </FeedLayout>
    </MainLayout>

  );
};

export default CreateCommunity;